//Importación de librerias
//---------------SIPSIC---------------
//Catalogos
import C003Psicologos from '../../../src/components/SIPSIC/Comun/Catalogos/003Psicologos.vue'
import C009Areas from '../../../src/components/SIPSIC/Comun/Catalogos/009Areas.vue'
import C004EstatusDeDictamen from '../../../src/components/SIPSIC/Comun/Catalogos/004EstatusDeDictamen.vue'
import C006EstatusCita from '../../../src/components/SIPSIC/Comun/Catalogos/006EstatusCita.vue'
import C010TiposPlantillas from '../../../src/components/SIPSIC/Comun/Catalogos/010TiposPlantillas.vue'
import C012TemasEvaluaciones from '../../../src/components/SIPSIC/Comun/Catalogos/012TemasEvaluaciones.vue'
import C013SalasLudicas from '../../../src/components/SIPSIC/Comun/Catalogos/013SalasLudicas.vue'


//Creamos y asignamos los datos necesarios de SICCIJ
const sipsic = [
  { Proviene: 'SIPSIC', Nombre: 'C003Psicologos', datos: C003Psicologos },
  { Proviene: 'SIPSIC', Nombre: 'C009Areas', datos: C009Areas },
  { Proviene: 'SIPSIC', Nombre: 'C004EstatusDeDictamen', datos: C004EstatusDeDictamen },
  { Proviene: 'SIPSIC', Nombre: 'C006EstatusCita', datos: C006EstatusCita },
  { Proviene: 'SIPSIC', Nombre: 'C010TiposPlantillas', datos: C010TiposPlantillas },
  { Proviene: 'SIPSIC', Nombre: 'C012TemasEvaluaciones', datos: C012TemasEvaluaciones },
  { Proviene: 'SIPSIC', Nombre: 'C013SalasLudicas', datos: C013SalasLudicas }
]


//Exportamos los datos de SICCIJ
export default sipsic;



//////////////////
// WEBPACK FOOTER
// ./static/js/catalogos/sipsic.js
// module id = null
// module chunks = 